export default {"src":"/_next/static/media/image-user-data.aab457e5.svg","height":73,"width":87};